import { call, put, takeLatest } from 'redux-saga/effects';

import { currentCompany, notification } from '../../../actionTypes';
import dataProvider from '../../../store/dataProvider';

export function* suspend({ payload: { companyId, reason, coordinatorUserId } }) {
  try {
    const response = yield call(dataProvider.updateOnly, `Companies/${companyId}/suspend`, {
      reason,
      coordinatorUserId,
    });

    yield put({
      type: currentCompany.companyAdminInfo.suspend.end,
      payload: response.data,
    });

    yield put({
      type: notification.add,
      payload: { success: 'Contractor has been suspended successfully' },
    });
  } catch (e) {
    yield put({ type: currentCompany.companyAdminInfo.suspend.error });
    yield put({ type: notification.add, payload: { error: e.message } });
  }
}

export default function* suspendContractor() {
  yield takeLatest(currentCompany.companyAdminInfo.suspend.start, suspend);
}
